interface AvatarProps {
  src?: string | null;
  name: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showOnline?: boolean;
  isOnline?: boolean;
}

const sizeClasses = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-12 h-12 text-base',
  xl: 'w-16 h-16 text-lg',
} as const;

function getInitials(name: string): string {
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

export function Avatar({ src, name, size = 'md', showOnline, isOnline }: AvatarProps) {
  return (
    <div className="relative inline-flex">
      {src ? (
        <img
          src={src}
          alt={name}
          className={`${sizeClasses[size]} rounded-full object-cover ring-2 ring-white/10`}
        />
      ) : (
        <div
          className={`${sizeClasses[size]} rounded-full bg-brand-600 flex items-center justify-center font-semibold ring-2 ring-white/10`}
        >
          {getInitials(name)}
        </div>
      )}
      {showOnline ? (
        <span
          className={`absolute bottom-0 right-0 w-3 h-3 rounded-full ring-2 ring-surface-900 ${
            isOnline ? 'bg-success' : 'bg-surface-500'
          }`}
        />
      ) : null}
    </div>
  );
}
